import { FC, memo } from 'react'

import { ArrowLeft16, ArrowRight16, Icon16, Link16, Lock24, Refresh16 } from '@makyoapp/makyo-icon/icon'

interface BrowserFrameProps {
  url?: string
}

const BrowserFrame: FC<BrowserFrameProps> = memo(({ url = 'https://example.com' }) => {
  return (
    <div className='w-full h-fit mx-auto rounded-lg overflow-hidden border border-gray-200 shadow-lg'>
      <div className='bg-gray-100 border-b border-gray-200'>
        <div className='flex items-center gap-4'>
          <div className='flex items-center px-4 py-2 space-x-1.5'>
            <div className='w-3 h-3 rounded-full bg-red-500'></div>
            <div className='w-3 h-3 rounded-full bg-yellow-500'></div>
            <div className='w-3 h-3 rounded-full bg-green-500'></div>
          </div>
          <p className='text-gray-400'>Makyo App</p>
        </div>

        <div className='px-4 py-2 flex items-center space-x-2'>
          <div className='flex space-x-1'>
            <button className='p-1 rounded-sm hover:bg-gray-200' aria-label='Go back'>
              <ArrowLeft16 className='text-gray-600' aria-hidden='true' />
            </button>
            <button className='p-1 rounded-sm hover:bg-gray-200' aria-label='Go forward'>
              <ArrowRight16 className='text-gray-600' aria-hidden='true' />
            </button>
            <button className='p-1 rounded-sm hover:bg-gray-200' aria-label='Refresh'>
              <Refresh16 className='text-gray-600' aria-hidden='true' />
            </button>
          </div>

          <div className='flex-1 flex items-center bg-white rounded-lg border border-gray-300 px-3 py-1'>
            <Lock24 className='text-gray-400 mr-2' />
            <span className='text-sm text-gray-600 flex-1'>{url}</span>
            <button className='p-1 rounded-sm hover:bg-gray-100'>
              <Icon16 className='text-gray-400' />
            </button>
          </div>

          <button className='p-1 rounded-sm hover:bg-gray-200'>
            <Link16 className='text-gray-600' />
          </button>
        </div>
      </div>
    </div>
  )
})

BrowserFrame.displayName = 'BrowserFrame'

export default BrowserFrame
